const isDebug = process.env.REACT_APP_TRACE === 'true' ? true : false;
const isRenderDebug = process.env.REACT_APP_TRACE_RENDER === 'true' ? true : false;

const traceRendering = isRenderDebug ? console.log : (...params: unknown[])=>{};
const debugLog = isDebug ? console.log : (...params: unknown[]) => { };
const debugWarning = isDebug ? console.warn : (...params: unknown[]) => {};

export {
    isDebug,
    debugLog,
    debugWarning,
    traceRendering
}
